
export const authenticateUserLogin = async (userId, password, otp) => {
  const response = await fetch('/api/login-user', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ user_id: userId, password: password, otp: otp })
  });
  const jsonRes = await response.json();
  if (jsonRes.access_token && response.status === 200) {
    localStorage.setItem('access-token', jsonRes.access_token);
  } 
  return jsonRes

}

export const authenticateUserPassword = async (password, otp) => {
  const accessToken = localStorage.getItem('access-token');
  const response = await fetch('/api/auth-user-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
    body: JSON.stringify({ password: password, otp: otp })
  });
  const jsonRes = await response.json();
  if (jsonRes.access_token && response.status === 200) {
    localStorage.setItem('access-token', jsonRes.access_token);
  }
  return jsonRes
}

export const logoutUser = async () => {
  const accessToken = localStorage.getItem('access-token');
  const response = await fetch('/api/logout-user', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
  });
  const jsonRes = await response.json();
  return jsonRes
}

export const checkJwtAuth = async () => {
  const accessToken = localStorage.getItem('access-token');
  const res = await fetch('/api/verify-jwt-token', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
  });
  const json = await res.json();
  return json.auth
}

export const updatePassword = async (newPassword) => {
  const accessToken = localStorage.getItem('access-token');
  const userId = sessionStorage.getItem('user-id');
  const res = await fetch('/api/update-password', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
    body: JSON.stringify({ userId: userId, newPassword: newPassword })
  });
  const json = await res.json();
  return json
}

export const generateOtpKey = async () => {
  const accessToken = localStorage.getItem('access-token');
  const userId = sessionStorage.getItem('user-id');
  const res = await fetch('/api/generate-otp-provisioning-uri', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
    body: JSON.stringify({ userId: userId})
  });
  const json = await res.json();
  return json
}